const getters = {
  getMainFeatures: (state) => state.mainFeatures,
  getMainFeature: (state) => state.mainFeature,
};

export default getters;
